<div class="grid-header">
    <div class="flex-3 first" translate>column.nameOfTheList</div>
    <div class="flex-2" translate>column.reminder.createDate</div>
    <div class="flex-2" translate>column.createdBy</div>
    <div class="flex-half last"></div>
</div>